module.exports = __webpack_public_path__ + "static/me_lake_mason-7e4234ff40a66d2532732178b88f1a83.jpg";